import api from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect, select } from "redux-saga/effects";
import { ReducersTypes } from "@/redux/reducers/Models";
import { clearString } from "../../../utils/functions";

export interface Fetch {
  callback: (success: boolean, code?: string) => void;
}

export interface RequestUserTicketsAction {
  type: string;
  payload: Fetch;
}

export default function* requestUserTickets({
  payload,
}: RequestUserTicketsAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const getUser = (state: ReducersTypes) => state.userReducer;
    // @ts-expect-error
    const user: ReducersTypes["userReducer"] = yield select(getUser);

    const data = {
      placa: clearString(user?.plate || "").toUpperCase(),
    };

    const response = yield call(
      api.post,
      `/v1/vehicle-debts/internal-payment-receipt`,
      data,
    );

    const payloadData = Array.isArray(response?.data)
      ? response?.data
      : response?.data?.data;

    if (payloadData) {
      yield call(payload.callback, true, payloadData);
    } else {
      yield call(payload.callback, false, "error");
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
